import type { Container } from 'inversify'
import { ContainerModule } from 'inversify'
import { APIConfigProvider } from './config'
import {
  createBigbrotherClient,
  createCinnamonClient,
  createDerekClient,
  createHotelClient,
  createLogger,
} from './restClients'
import { TYPES } from './types'
import { createCinnamonWebSocketFactory } from './websocketFactory'

export const infrastructures = new ContainerModule(bindOptions => {
  const apiConfig = APIConfigProvider()
  bindOptions.bind(TYPES.APIConfig).toConstantValue(apiConfig)
  bindOptions
    .bind(TYPES.DerekClient)
    .toConstantValue(createDerekClient(apiConfig))
  bindOptions
    .bind(TYPES.CinnamonClient)
    .toConstantValue(createCinnamonClient(apiConfig))
  bindOptions
    .bind(TYPES.CinnamonWebSocketFactory)
    .toConstantValue(createCinnamonWebSocketFactory(apiConfig))
  bindOptions.bind(TYPES.Logger).toConstantValue(createLogger(apiConfig))
  bindOptions
    .bind(TYPES.BigbrotherClient)
    .toConstantValue(createBigbrotherClient(apiConfig))
  bindOptions
    .bind(TYPES.HotelClient)
    .toConstantValue(createHotelClient(apiConfig))
})

export const rebindAPIConfig = (container: Container, apiToken?: APIToken) => {
  const apiConfig = APIConfigProvider(apiToken)
  if (container.isBound(TYPES.APIConfig)) {
    container.rebindSync(TYPES.APIConfig).toConstantValue(apiConfig)
    container
      .rebindSync(TYPES.DerekClient)
      .toConstantValue(createDerekClient(apiConfig))
    container
      .rebindSync(TYPES.CinnamonClient)
      .toConstantValue(createCinnamonClient(apiConfig))
    container
      .rebindSync(TYPES.CinnamonWebSocketFactory)
      .toConstantValue(createCinnamonWebSocketFactory(apiConfig))
    container.rebindSync(TYPES.Logger).toConstantValue(createLogger(apiConfig))
    container
      .rebindSync(TYPES.BigbrotherClient)
      .toConstantValue(createBigbrotherClient(apiConfig))
    container
      .rebindSync(TYPES.HotelClient)
      .toConstantValue(createHotelClient(apiConfig))
    return
  }
  container.bind(TYPES.APIConfig).toConstantValue(apiConfig)
  container
    .bind(TYPES.DerekClient)
    .toConstantValue(createDerekClient(apiConfig))
  container
    .bind(TYPES.CinnamonClient)
    .toConstantValue(createCinnamonClient(apiConfig))
  container
    .bind(TYPES.CinnamonWebSocketFactory)
    .toConstantValue(createCinnamonWebSocketFactory(apiConfig))
  container.bind(TYPES.Logger).toConstantValue(createLogger(apiConfig))
  container
    .bind(TYPES.BigbrotherClient)
    .toConstantValue(createBigbrotherClient(apiConfig))
  container
    .bind(TYPES.HotelClient)
    .toConstantValue(createHotelClient(apiConfig))
}

export const clearAPIConfig = (container: Container): void => {
  rebindAPIConfig(container)
}
